<template>
  <base-layout
    :readOnly="readOnly"
    :value="value"
    :text-align="textAlign"
    :label-width="labelWidth"
    :is-require="isRequire"
    :is-dipatch="isDipatch"
    :styleType="styleType"
    :label="label"
	:is-dipatch-style="isDipatchStyle"
    :labelPaddingRight="labelPaddingRight"
  >
    <el-date-picker
      v-model="inputValue"
      clearable
      :type="type"
      slot="control"
      :format="format"
      :disabled="disabled"
      :picker-options="pickerOptions"
      :placeholder="placeholder"
      @change="handleEmitValue"
      @blur="handleEmitBlur"
    ></el-date-picker>
  </base-layout>
</template>

<script>
import baseLayout from "./base-layout.vue";
import { handleEmitValue, handleEmitBlur, datePicker } from "./../props-config";
export default {
  name: "base-date-picker",
  components: {
    baseLayout
  },
  computed: {
    inputValue: {
      get() {
        return this.value;
      },
      set(val) {
        // console.log(val);
        // if (this.isDipatch) {
        // } else {
        //   this.$emit("input", val);
        // }
        if (val) {
          if (this.type === "daterange" || this.type === "datetimerange") {
            this.$emit("input", [
              this.$utils.formatTime(val[0], this.valueFormat),
              this.$utils.formatTime(val[1], this.valueFormat)
            ]);
          } else {
            const inputVal = this.$utils.formatTime(val, this.valueFormat);
            this.$emit("input", inputVal);
            this.isDipatch && this.$store.dispatch("updateObject", {
              obj: this.dipatchObj,
              attr: this.dipatchAttr,
              val: inputVal
            });
          }
        } else {
          if (this.isFirst === true) {
            this.isFirst = false;
            return false;
          }
          this.$emit("input", val);
          this.isDipatch && this.$store.dispatch("updateObject", {
            obj: this.dipatchObj,
            attr: this.dipatchAttr,
            val: val
          });
        }
      }
    }
  },
  props: {
    ...datePicker,
    // year/month/date/week/ datetime/datetimerange/daterange
    type: {
      type: String,
      default: "date"
    },
    // '{y}/{m}/{d} {h}:{i}:{s}' 返回的时间格式
    valueFormat: {
      type: String,
      default: "{y}-{m}-{d}"
    },
    pickerOptions: {
      type: Object,
      default:()=>({})
    },
    // 年 yyyy，月 MM，日 dd，小时 HH，分 mm，秒 ss
    // 显示的时间格式
    format: {
      type: String,
      default: "yyyy-MM-dd"
    }
  },
  mounted() {},
  methods: {
    handleEmitValue,
    handleEmitBlur
  },
  data() {
    return {
      isFirst: true
    };
  }
};
</script>
<style scoped>
.el-date-editor--datetimerange.el-input, .el-date-editor--datetimerange.el-input__inner {
  width: 100% !important;
}
</style>
